__turbopack_context__.v({
  "btn": "page-module__N1ZK9G__btn",
  "error": "page-module__N1ZK9G__error",
  "field": "page-module__N1ZK9G__field",
  "form-box": "page-module__N1ZK9G__form-box",
  "form-side": "page-module__N1ZK9G__form-side",
  "illustration": "page-module__N1ZK9G__illustration",
  "links": "page-module__N1ZK9G__links",
  "page": "page-module__N1ZK9G__page",
  "sitename": "page-module__N1ZK9G__sitename",
  "success": "page-module__N1ZK9G__success",
  "tagline": "page-module__N1ZK9G__tagline",
});
